<template>
  <div :style="{ display: display_type }" class="membership_payment_width">
    <v-container class="pl-10">
      <div>
        <p class="display-1 mt-7">결제 관리</p>
        <p class="mb-0 subtitle-1 font-weight-light">
          커스텀 멤버십 서비스 결제 및 내역 확인을 할 수 있습니다.<br />
          '결제하기' 버튼을 클릭하여 결제하실 수 있습니다.
        </p>
      </div>
      <Payment ref="Payment"></Payment>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>
<style scoped>
.container {
  max-width: 100%;
}
</style>
<script>
const Payment = () =>
  import(
    /* webpackChunkName: "ViewPayment" */ "@/components/membership/payment/Payment.vue"
  );
import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  data() {
    return {
      display_type: "none",
    };
  },
  components: {
    Payment,
    PageLoadingProgress,
  },
  methods: {
    serchShow: function() {
      this.progressHide();
    },

    progressShow: function() {
      this.display_type = "none";
      this.$refs.PageLoadingProgress.show();
    },
    progressHide: function() {
      this.display_type = "block";
      this.$refs.PageLoadingProgress.hide();
    },
  },
  created: function() {
    // PG에서 결제 후 넘어 오게 되면 부모창 닫음

    const mall_id = this.$store.state.mallId;
    let referrer = document.referrer;
    let searchUrl = `${mall_id}.cafe24.com`;
    //PG 결제 후 접속 시
    if (referrer.indexOf(searchUrl) !== -1) {
      //부모창 새로 고침
      opener.location.href = opener.document.URL;
      // 결제한 페이지 닫기
      window.open("", "_self", "");
      window.close();
    }
  },

  mounted: function() {
    this.progressShow();
  },
};
</script>
